<template>
  <div>
    <label class="w-sbold fs-14 mb-1">Educación</label>
    <div class="mb-3">
      <EducationForm mode="save" />
    </div>

    <div v-if="profile.educations.length" class="row gy-3">
      <div
        v-for="education of profile.educations"
        :key="`education-${education.id}`"
        class="col-12"
      >
        <Education :body="education" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  components: {
    Education: () => import(/* webpackChunkName: "profile-education" */'@/components/panel/edit/Education.vue'),
    EducationForm: () => import(/* webpackChunkName: "profile-education-form" */'@/components/panel/edit/EducationForm.vue'),
  },
  watch: {
    profile() {
      alert('dd');
    },
  },
  computed: {
    ...mapState({
      userData: (state) => state.user.userData,
      profile: (state) => state.editConnecta.profile,
    }),
  },
};
</script>
